import { userService } from './../../../Services/userService';
import { MotorStepService } from './../../../Services/MotorStepService';
import { Subscription } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { MotorProposal } from '../../../Models/MotorProposal';
import { BindMdl } from '../../../Models/BindMdl';
import { restURL } from '../../../Models/restURL';
import { motorProposalService } from '../../../Services/motorProposalService';
import { LanguageService } from '../../../Services/languageService';
import { MotorproposalTrackingService } from '../../../Services/MotorproposalTrackingService';
import { mdlPayloadRequest } from '../../../Models/mdlPayloadRequest';
import { mdlPayloadResponse } from '../../../Models/mdlPayloadResponse';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import swal from 'sweetalert2';
import { mdlAddAdditionalCovers, mdlCovers } from '../../../Models/mdlAddAdditionalCovers';
import { mdlUpdatePasswordRes } from '../../../Models/mdlUpdatePasswordRes';
import { mdlAnnouncementRes } from '../../../Models/mdlAnnouncementRes';

@Component({
  selector: 'PremiumInfo',
  templateUrl: './PremiumInfo.html',
  styleUrls: ['./PremiumInfo.css']
})
export class PremiumInfo {

  public prObj: MotorProposal = new MotorProposal();
  public bindObj: BindMdl = new BindMdl();
  public isShowLoading: boolean;
  public LngSubscription: Subscription;
  public Lng: string;
  public showTPLCompOnly: boolean;
  public showCompOnly: boolean;
  public isError: boolean;
  public ErrorMsg: string;
  public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
  public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();
  public ProposalLan: string | undefined;
  public objAddAdditionalCovers: mdlAddAdditionalCovers = new mdlAddAdditionalCovers();
  public Announcement: mdlAnnouncementRes = new mdlAnnouncementRes();

  constructor(private translate: TranslateService, private EncriptService: motorProposalService, private router: Router, private http: HttpClient, private url: restURL, private proposalService: motorProposalService, private lngService: LanguageService, private trackingObj: MotorproposalTrackingService, private stepServiceObj: MotorStepService, private userinfo: userService) {
    moment.locale("en-US");
    this.stepServiceObj.setStepNum(3);
    this.LngSubscription = this.lngService.grtLng().subscribe(lng => { this.Lng = lng });

    if (sessionStorage.getItem("Language") != null) {
      this.Lng = sessionStorage.getItem("Language");
    }
    else {
      this.Lng = "en";
    }
    if (this.Lng != null) {
      this.ProposalLan = this.Lng == "ar" ? "A" : "E";
    }
    this.prObj = this.proposalService.getProposalObj();
    this.isShowLoading = false;
    this.showTPLCompOnly = false;
    this.showCompOnly = false;
    this.isError = false;
    this.ErrorMsg = "";
    this.bindObj = this.proposalService.getBindObj();
    this.getPremium();

  }

GetAnnouncement() {
  this.isShowLoading = true;
  let Req = {
    UserId: "331",
    Channel: "OLD_B2C",
    PageType: "Premium"
  };
  this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(Req));
  this.http.post<mdlPayloadResponse>(
    this.url.baseURL + "MotorOnline/GetAnnouncement",
    this.objPayloadRequest,
    this.userinfo.getHttpOptions()
  )
  .toPromise()
  .then((result) => {
    this.isShowLoading = false;
    this.objPayloadResponse = result;
    this.Announcement = JSON.parse(
      JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse))
    );
    
    if (this.Announcement.StatusCode == "S") {
      let stHTML : string = this.Lng == "en" ? this.Announcement.EngMessage : this.Announcement.ArMessage;
      let Title : string = this.Announcement.Title;

      Swal({
        title: this.translate.instant(Title),
        html: this.translate.instant(stHTML),
        type: "info",
        background: 'white',
        customClass: 'swal-wide !important',
        width: '25%',
        confirmButtonText: 'Ok'
      });
    }
  },
  (error) => {
    this.isShowLoading = false;
    this.userinfo.checkTokenStatus(error);
  });
}

  goPrev() {
    if (this.prObj.st.StatusCode == "F") {
      this.prObj.st.StatusCode = "";
    }
    this.proposalService.saveProposalObj(this.prObj);
    this.proposalService.saveBindObj(this.bindObj);
    if (this.prObj.isDriverRequired == true) {
      sessionStorage.setItem("CurrentRoute", "DriverInfo");
      this.router.navigate(['NewDashboard/MotorProposalForm/DriverInfo']);
    }
    else {
      sessionStorage.setItem("CurrentRoute", "InsuredInfo");
      this.router.navigate(['NewDashboard/MotorProposalForm/InsuredInfo']);
    }

  }

  goNext() {
    this.proposalService.saveProposalObj(this.prObj);
    this.proposalService.saveBindObj(this.bindObj);
    if (this.prObj.isEditProposal == false) {
      this.prObj.trackingObj.ScreenNo = "P";
      this.trackingObj.saveTrackStatus(this.prObj)
    }

    sessionStorage.setItem("CurrentRoute", "VehicleDetails");
    this.router.navigate(['NewDashboard/MotorProposalForm/VehicleDetails']);
  }

  getPremium() {
    this.isError = false;
    this.isShowLoading = true;
    this.prObj.HasTPL = false;
    this.prObj.HasComprehensive = false;


    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.prObj));

    //this.http.post<MotorProposal>(this.url.baseURL + "/newPolicy/CalculatePremium", this.prObj, this.userinfo.getHttpOptions()).toPromise()
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/newPolicy/CalculatePremium", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise()
      .then((res) => {
        //this.prObj = res;
        //New Line Start
        this.objPayloadResponse = res;
        let objResObj: MotorProposal = new MotorProposal();
        objResObj = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));

        if (objResObj.RegNo != this.prObj.RegNo) {
          Swal("Invalid Response", "Technical Error: Request Object Does Not Match With Response Object", "error")
          this.router.navigate(['BeforeLogin/NewReg']);
          return;
        }
        this.prObj = objResObj;
        //NewLine End
        this.proposalService.saveProposalObj(this.prObj);
        this.isShowLoading = false;
        if (this.prObj.st.StatusCode == "F") {
          this.isError = true;
          this.Lng == "ar" ? this.ErrorMsg = this.prObj.st.StatusDescAr : this.ErrorMsg = this.prObj.st.StatusDesc;
          swal(this.Lng == "ar" ? this.ErrorMsg = this.prObj.st.StatusDescAr : this.ErrorMsg = this.prObj.st.StatusDesc)
          sessionStorage.setItem("CurrentRoute", "Welcome");
          this.router.navigate(['/NewDashboard/Welcome']);
          return;
        }
        else {
          
          this.isError = false;
          this.ErrorMsg = "";
          const message = this.Lng == "ar"
            ? this.prObj.st.StatusDescAr
            : this.prObj.st.StatusDesc;
          swal(message).then(() => {
            this.GetAnnouncement();
          });
        }
        this.prObj.DownLoadProposal_Tpl = "5515:" + this.prObj.EditedProposalNo + ":" + this.prObj.Insured_IDNo.substring(0, 3)
        this.prObj.DownLoadProposal_Comp = "5520:" + this.prObj.EditedProposalNo + ":" + this.prObj.Insured_IDNo.substring(0, 3)

        this.calcCompPremium();
        this.calcTPLPremium();
        this.displayPremiumOption();
      }, (error) => {
        this.isShowLoading = false;
        this.userinfo.checkTokenStatus(error);

      });
  }

  calcCompPremium() {
    this.prObj.CompNCDAmount = 0; this.prObj.CompLDAmount = 0; this.prObj.CompCrossSellDiscount = 0;
    this.prObj.CompPromoDiscount = 0; this.prObj.CompUserDiscountAmt = 0; this.prObj.COMP_Driver_DISC_AMOUNT = 0;
    this.prObj.CompTotalPremiumBeforeVAT = 0; this.prObj.CompVAT_AMOUNT = 0; this.prObj.CompTotalPremium = 0;
    this.prObj.CompGrossPremium = 0; this.prObj.CompDriverDiscAmount = 0;
    this.prObj.CompNCDPercentage = 0; this.prObj.CompLDPercentage = 0; this.prObj.CompCrossSellDisPercent = 0;
    this.prObj.CompPromoPercent = 0; this.prObj.CompUserDiscountPer = 0; this.prObj.CompVAT_PERCENT = 0;
    this.prObj.CompDriverDiscPer = 0;

    for (let cover of this.prObj.compCovers) {
      if (cover.isSelected === true) {
        this.prObj.CompGrossPremium = this.prObj.CompGrossPremium + cover.GrossAmount;
        this.prObj.CompNCDAmount = this.prObj.CompNCDAmount + cover.NCDAmount;
        this.prObj.CompLDAmount = this.prObj.CompLDAmount + cover.LDAmount;
        this.prObj.CompCrossSellDiscount = this.prObj.CompCrossSellDiscount + cover.CrossSellDiscAmount;
        this.prObj.CompPromoDiscount = this.prObj.CompPromoDiscount + cover.PromoDiscAmount;
        this.prObj.CompUserDiscountAmt = this.prObj.CompUserDiscountAmt + cover.UserDiscount;
        this.prObj.COMP_Driver_DISC_AMOUNT = this.prObj.COMP_Driver_DISC_AMOUNT + cover.DriverDiscAmount;
        this.prObj.CompTotalPremiumBeforeVAT = this.prObj.CompTotalPremiumBeforeVAT + cover.TotalPrice;
        this.prObj.CompVAT_AMOUNT = this.prObj.CompVAT_AMOUNT + cover.Vat_Amount;
        this.prObj.CompDriverDiscAmount = this.prObj.CompDriverDiscAmount + cover.DriverDiscAmount;
        if (cover.IsBasic === true) {
          this.prObj.CompNCDPercentage = cover.NCDPercent;
          this.prObj.CompLDPercentage = cover.LDPercent;
          this.prObj.CompCrossSellDisPercent = cover.CrossSellDiscPer;
          this.prObj.CompPromoPercent = cover.PromoDiscPer;
          this.prObj.CompUserDiscountPer = cover.UserDiscPer;
          this.prObj.CompVAT_PERCENT = cover.Vat_Per;
          this.prObj.CompDriverDiscPer = cover.DriverDiscPer;
        }

      }
    }

    if (this.prObj.SurplusAmount > 0){
      this.prObj.CompTotalPremium = (this.prObj.CompTotalPremiumBeforeVAT + this.prObj.CompVAT_AMOUNT + this.prObj.COMP_UPR_VAT_AMOUNT) - this.prObj.SurplusAmount;
    }
    else{
      this.prObj.CompTotalPremium = this.prObj.CompTotalPremiumBeforeVAT + this.prObj.CompVAT_AMOUNT + this.prObj.COMP_UPR_VAT_AMOUNT;
    }

  }

  calcPremium(coverCode) {
    if (coverCode == "551502") {
      if (this.prObj.tplCovers.filter(t => t.CoverCode == "551502")[0].isSelected) {
        this.prObj.tplCovers.filter(t => t.CoverCode == "551503")[0].isSelected = true;
      }
      else {
        this.prObj.tplCovers.filter(t => t.CoverCode == "551503")[0].isSelected = false;
      }
    }
    if (coverCode == "551503") {
      if (!this.prObj.tplCovers.filter(t => t.CoverCode == "551503")[0].isSelected) {
        this.prObj.tplCovers.filter(t => t.CoverCode == "551502")[0].isSelected = false;
      }
    }

    this.calcTPLPremium();
    // this.AddAdditionalCovers("5515");
  }

  calCompPremium(coverCode) {



    if (coverCode == "552006") {
      if (this.prObj.compCovers.filter(t => t.CoverCode == "552006")[0].isSelected) {
        this.prObj.compCovers.filter(t => t.CoverCode == "552005")[0].isSelected = true;


      }
      else {
        this.prObj.compCovers.filter(t => t.CoverCode == "552005")[0].isSelected = false;

      }
    }
    if (coverCode == "552005") {
      if (!this.prObj.compCovers.filter(t => t.CoverCode == "552005")[0].isSelected) {
        this.prObj.compCovers.filter(t => t.CoverCode == "552006")[0].isSelected = false;
      }
    }

    this.calcCompPremium();
    //this.AddAdditionalCovers("5520");
  }

  calcTPLPremium() {
    this.prObj.NCDAmount = 0; this.prObj.LDAmount = 0; this.prObj.CrossSellDiscount = 0;
    this.prObj.PromoDiscount = 0; this.prObj.UserDiscountAmt = 0; this.prObj.Driver_DISC_AMOUNT = 0;
    this.prObj.TotalPremiumBeforeVAT = 0; this.prObj.VAT_AMOUNT = 0; this.prObj.TotalPremium = 0;
    this.prObj.GrossPremium = 0; this.prObj.VAT_PERCENT = 0; this.prObj.DriverDiscPer = 0;
    this.prObj.DriverDiscAmount = 0; this.prObj.NCDPercentage = 0; this.prObj.LDPercentage = 0;
    this.prObj.CrossSellDisPercent = 0; this.prObj.PromoPercent = 0; this.prObj.UserDiscountPer = 0;
    this.prObj.VAT_PERCENT = 0; this.prObj.DriverDiscPer = 0;


    for (let cover of this.prObj.tplCovers) {
      if (cover.isSelected === true) {
        this.prObj.GrossPremium = this.prObj.GrossPremium + cover.GrossAmount;
        this.prObj.NCDAmount = this.prObj.NCDAmount + cover.NCDAmount;
        this.prObj.LDAmount = this.prObj.LDAmount + cover.LDAmount;
        this.prObj.CrossSellDiscount = this.prObj.CrossSellDiscount + cover.CrossSellDiscAmount;
        this.prObj.PromoDiscount = this.prObj.PromoDiscount + cover.PromoDiscAmount;
        this.prObj.UserDiscountAmt = this.prObj.UserDiscountAmt + cover.UserDiscount;
        this.prObj.Driver_DISC_AMOUNT = this.prObj.Driver_DISC_AMOUNT + cover.DriverDiscAmount;
        this.prObj.TotalPremiumBeforeVAT = this.prObj.TotalPremiumBeforeVAT + cover.TotalPrice;
        this.prObj.VAT_AMOUNT = this.prObj.VAT_AMOUNT + cover.Vat_Amount;
        this.prObj.DriverDiscAmount = this.prObj.DriverDiscAmount + cover.DriverDiscAmount;

        if (cover.IsBasic === true) {
          this.prObj.NCDPercentage = cover.NCDPercent;
          this.prObj.LDPercentage = cover.LDPercent;
          this.prObj.CrossSellDisPercent = cover.CrossSellDiscPer;
          this.prObj.PromoPercent = cover.PromoDiscPer;
          this.prObj.UserDiscountPer = cover.UserDiscPer;
          this.prObj.VAT_PERCENT = cover.Vat_Per;
          this.prObj.DriverDiscPer = cover.DriverDiscPer;
        }

      }
    }

    if (this.prObj.SurplusAmount > 0){
      this.prObj.TotalPremium = (this.prObj.TotalPremiumBeforeVAT + this.prObj.VAT_AMOUNT + this.prObj.UPR_VAT_AMOUNT) - this.prObj.SurplusAmount;
    }
    else{
      this.prObj.TotalPremium = this.prObj.TotalPremiumBeforeVAT + this.prObj.VAT_AMOUNT + this.prObj.UPR_VAT_AMOUNT;
    }
    
  }

  ApplyMotorPromo() {

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.prObj));
    this.isShowLoading = true;
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/newPolicy/ApplyMotorPromo", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise()
      .then((res) => {
        this.objPayloadResponse = res;
        this.prObj = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));

        this.proposalService.saveProposalObj(this.prObj);
        this.isShowLoading = false;
        this.prObj.DownLoadProposal_Tpl = "5515:" + this.prObj.EditedProposalNo + ":" + this.prObj.Insured_IDNo.substring(0, 3)
        this.prObj.DownLoadProposal_Comp = "5520:" + this.prObj.EditedProposalNo + ":" + this.prObj.Insured_IDNo.substring(0, 3)

        Swal(this.translate.instant(this.prObj.PromoRes.StatusDesc));
        // if (this.prObj.PromoRes.StatusCode == "F") {
        //   this.isError = true;
        //   Swal(this.translate.instant(this.prObj.PromoRes.StatusDesc))
        // }
        // else {
        //   this.isError = false;
        //   Swal(this.translate.instant(this.prObj.PromoRes.StatusDesc))
        //   this.ErrorMsg = "";
        //   this.Lng == "ar" ? this.ErrorMsg = this.prObj.PromoRes.StatusDescAr : this.ErrorMsg = this.prObj.PromoRes.StatusDesc;

        // }
        this.calcCompPremium();
        this.calcTPLPremium();
        this.displayPremiumOption();

      }, (error) => {
        this.isShowLoading = false;
        this.userinfo.checkTokenStatus(error);

      });

  }

  goForTPL() {
    if (this.prObj.isTPLActive) {
      this.Lng == "ar" ? Swal("توجد وثيقة مصدرة بنفس الرقم التسلسلي / الرقم الجمركي") : Swal("Policy already Active with this Sequence /Custom Id");
      return;
    }
    this.isError = false;
    this.ErrorMsg = "";
    this.prObj.ProductCode = "5515";
    this.prObj.SelectedProductCode = "5515";
    this.prObj.isTPLSelected = true;
    this.proposalService.saveProposalObj(this.prObj);
    this.proposalService.saveBindObj(this.bindObj);
    this.prObj.trackingObj.ScreenNo = "P";
    //this.trackingObj.saveTrackStatus(this.prObj)
    sessionStorage.setItem("CurrentRoute", "VehicleDetails");
    this.router.navigate(['NewDashboard/MotorProposalForm/VehicleDetails']);
  }

  goForComprehensive() {

    if (this.prObj.isCOMPActive) {
      this.Lng == "ar" ? Swal("توجد وثيقة مصدرة بنفس الرقم التسلسلي / الرقم الجمركي") : Swal("Policy already Active with this Sequence /Custom Id");
      return;
    }
    this.isError = false;
    this.ErrorMsg = "";
    this.prObj.ProductCode = "5520";
    this.prObj.SelectedProductCode = "5520";
    this.prObj.isCompSelected = true;
    this.proposalService.saveProposalObj(this.prObj);
    this.proposalService.saveBindObj(this.bindObj);
    this.prObj.trackingObj.ScreenNo = "P";
    this.trackingObj.saveTrackStatus(this.prObj)
    sessionStorage.setItem("CurrentRoute", "VehicleDetails");
    this.router.navigate(['NewDashboard/MotorProposalForm/VehicleDetails']);
  }

  displayPremiumOption() {
    if (this.prObj.productType == "5520") {
      this.showTPLCompOnly = false;
      this.showCompOnly = true;
    }
    else {
      this.showTPLCompOnly = true;
      this.showCompOnly = false;
    }
  }

  AddAdditionalCovers(Product) {

    let objCovers: Array<mdlCovers> = new Array<mdlCovers>()
    if (Product == "5515") {
      objCovers = this.prObj.tplCovers.filter(t => t.IsMandatory == false && t.isSelected == true).filter(t => t.CoverCode);
    }
    else if (Product == "5520") {
      objCovers = this.prObj.compCovers.filter(t => t.IsMandatory == false && t.isSelected == true).filter(t => t.CoverCode);
    }

    this.objAddAdditionalCovers.ProposalNo = this.prObj.EditedProposalNo;
    this.objAddAdditionalCovers.Covers = objCovers;
    this.objAddAdditionalCovers.ProductCode = Product;


    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.objAddAdditionalCovers));
    this.isShowLoading = true;
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/newPolicy/AddAdditionalCovers", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise()
      .then((res) => {
        this.isShowLoading = false;
        //this.prObj = res;
        //New Line Start
        this.objPayloadResponse = res;
        let objRes: mdlUpdatePasswordRes;
        objRes = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
        //NewLine End

        Swal(this.translate.instant(objRes.ErrorMsg))

      }, (error) => {
        this.isShowLoading = false;
        this.userinfo.checkTokenStatus(error);

      });
  }
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/PremiumInfo/PremiumInfo.ts